import React, { Component } from "react";
import { reduxForm, FieldArray, getFormValues } from "redux-form";
import { connect } from "react-redux";
import { map } from "lodash";
import classNames from "classnames";

import CroField from "../../components/generalForm/CroField";
import CroSubHead from "../../components/generalForm/CroSubhead";
import Button from "../../../../components/form/Button";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import Input from "../../../../components/form/Input";
import {
  getInitPlacements,
  helpCategoriesEnum,
  helpGeneralEnum,
  helpInEnum,
  helpOnEnum,
  helpOutEnum,
  helpOvmEnum,
  helpPoint3Enum,
  helpRequestInitiativeEnum,
  helpPoint4Enum,
  helpSenatorsEnum,
} from "../../helpEnum";
import fetch from "../../../../utils/fetch";
import { breadcrumbs } from "../../../../actions/appActions";
import { styles } from "../../index";
import { saveHelps } from "../../CroActions";
import ShowOverviewHistoryButton from "../../components/audit/ShowOverviewHistoryButton";
import { setLoading } from "../../../../actions/appActions";

const HelpComponent = ({ fields, name, disabled, helpEnum }) => (
  <div className="cro-form in help">
    {fields.map((item, index) =>
      helpEnum[fields.get(index).placement].subhead ? (
        helpEnum[fields.get(index).placement].bold ? (
          <CroSubHead
            key={index}
            title={helpEnum[fields.get(index).placement].l}
            name={`${item}.text`}
          />
        ) : (
          <CroSubHead
            key={index}
            title={helpEnum[fields.get(index).placement].l}
            name={`${item}.text`}
            style={{ fontWeight: "normal" }}
          />
        )
      ) : (
        <CroField
          key={index}
          title={helpEnum[fields.get(index).placement].l}
          name={`${item}.text`}
          component={Input}
          disabled={disabled}
          fullWidth
          multiline
          maxlen={1000}
        />
      ),
    )}
  </div>
);

class HelpEditForm extends Component {
  state = {
    selectedHelp: Object.keys(helpCategoriesEnum)[0],
    data: null,
  };

  selectedEnum = helpGeneralEnum;

  async componentWillMount() {
    const { breadcrumbs, dispatch } = this.props;

    dispatch(setLoading(true, "Načítání nápověd..."));
    breadcrumbs([{ label: "Nápovědy" }]);

    await this.loadData();
    dispatch(setLoading());
  }

  async loadData() {
    const { initialize, dispatch } = this.props;

    dispatch(setLoading(true, "Načítání nápověd..."));

    const response = await fetch("/api/help/getall", dispatch);
    const json = await response.json();
    this.setState({ data: json });
    initialize({ array: getInitPlacements(json, this.selectedEnum) });

    dispatch(setLoading());
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.formValues !== nextProps.formValues;
  }

  async handleOnClickTabBarItem(item) {
    const { onSubmit, formValues, pristine, submitSucceeded } = this.props;

    this.setState({ selectedHelp: item.r });

    switch (item.r) {
      case Object.keys(helpCategoriesEnum)[0]:
        this.selectedEnum = helpGeneralEnum;
        break;
      case Object.keys(helpCategoriesEnum)[1]:
        this.selectedEnum = helpRequestInitiativeEnum;
        break;
      case Object.keys(helpCategoriesEnum)[2]:
        this.selectedEnum = helpOvmEnum;
        break;
      case Object.keys(helpCategoriesEnum)[3]:
        this.selectedEnum = helpInEnum;
        break;
      case Object.keys(helpCategoriesEnum)[4]:
        this.selectedEnum = helpOnEnum;
        break;
      case Object.keys(helpCategoriesEnum)[5]:
        this.selectedEnum = helpOutEnum;
        break;
      case Object.keys(helpCategoriesEnum)[6]:
        this.selectedEnum = helpPoint3Enum;
        break;
      case Object.keys(helpCategoriesEnum)[7]:
        this.selectedEnum = helpPoint4Enum;
        break;
      case Object.keys(helpCategoriesEnum)[8]:
        this.selectedEnum = helpSenatorsEnum;
        break;
      default:
        this.selectedEnum = helpGeneralEnum;
    }

    if (!pristine && !submitSucceeded) {
      await onSubmit(formValues);
    }
    await this.loadData();
  }

  render() {
    const { error, submitting, disabled, handleSubmit, onSubmit, auth } = this.props;

    return (
      <div className="helpPage">
        <ShowOverviewHistoryButton auth={auth} segment="napovedy" />
        <div className="pageTabs pageTabs--help">
          <div className="pageTabs__scroller">
            {map(helpCategoriesEnum, (item) => {
              return (
                <button
                  type="button"
                  className={classNames("pageTabs__tab", {
                    "pageTabs__tab--active": item.r === this.state.selectedHelp,
                    "pageTabs__tab--historical": item.historical,
                  })}
                  onClick={() => this.handleOnClickTabBarItem(item)}
                >
                  {item.l}
                </button>
              );
            })}
          </div>
        </div>

        <form className="cro-form long-label helpForm">
          <div className="helpForm__section">
            <FieldArray
              className="full"
              name="array"
              component={HelpComponent}
              disabled={disabled}
              helpEnum={this.selectedEnum}
            />
          </div>

          <div className="helpForm__footer">
            <div className="helpForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}

              <div className="helpForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Form = reduxForm({
  form: "help_edit_form",
})(HelpEditForm);

export default connect(
  (state) => ({ formValues: getFormValues("help_edit_form")(state) }),
  { breadcrumbs, onSubmit: saveHelps },
)(Form);
